import styleInject from 'style-inject';

var css_248z = ".Tabs-module_container__bA7RL,\n.Tabs-module_button__bEKm0 {\n\ttransition: color 0.2s, background-color 0.2s, box-shadow 0.2s !important;\n}\n\n.Tabs-module_count__XABSp {\n\tmargin-left: 4px;\n}\n";
var styles = {"container":"Tabs-module_container__bA7RL","button":"Tabs-module_button__bEKm0","count":"Tabs-module_count__XABSp"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
